import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/highlands-ranch-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-highlands-ranch-colorado",
      statusCode: 301,
    });
  },
});
